import activityCategoryAPI from '@/apis/di/activityCategoryAPI';
import {defineStore} from 'pinia';
import {BaseDictionaryStore} from '@/stores/baseDictionaryStore';
import {ModuleActivityCategory} from '@/stores/moduleConst';

const activityCategoryStore = new BaseDictionaryStore(activityCategoryAPI);
export const useActivityCategoryStore = defineStore(ModuleActivityCategory, {
  state: () => ({
    ...activityCategoryStore.state,
    _config: {
      key: 'activity_category_id',
      code: 'activity_category_code',
      name: 'activity_category_name',
      table: 'di_activity_category',
      quickFollow: 'active',
      moduleName: 'Loại hoạt động tài chính',
      defaultSort: 'activity_category_code',
      isTree: true,
    },
    moduleName: 'activityCategory',
  }),
  actions: {
    ...activityCategoryStore.action,
    getDataFromCombobox(id) {
      const allItems = this.$state.items;
      return allItems.filter(x => x.activity_category_id != id);
    },
  },
  getters: {
    ...activityCategoryStore.getters,
  },
});
